import React, {useEffect, useState, forwardRef, useImperativeHandle} from 'react'
import { CheckBox } from 'sr/helpers/ui-components/company/CheckBox'
import CheckBoxHandle from 'sr/helpers/functions/CheckBoxHandle'
import { FormattedMessage } from 'react-intl'
import { getJobTypeCategory } from 'sr/utils/api/getJobTypeCategory'

export const JobTypeChange = forwardRef((props:any , ref) => {

    const [jobtype, setJobType] = useState<any[]>([]);
    const [error, setError] = useState('');

    useEffect(()=> {
        setJobType(props?.data?.job_type)
    },[props?.data])

    useEffect(()=> {
     const data = {
      job_type:jobtype
     }
     props.HandleDataProps(data)
    },[jobtype])

        const [jobTypes, setJobTypes] = useState([])
                useEffect(()=>{
                  const fetchJobType = async ()=>{
            try {
            const res = await getJobTypeCategory()
            if(res?.success===true){
              setJobTypes(res?.data)
            }
            }
            catch(e:any){
            
            }
                  }
                  fetchJobType()
                },[])

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!jobtype || jobtype.length === 0) {
        setError('Please select at least one Job Type')
        return false
      }
      setError('')
      return true
    }
  }))
    
  return (
    <>
    <p className='pt-8 text-base '><FormattedMessage id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.JOBTYPE.TITLE" defaultMessage="Job type" /></p>
<div className="flex flex-wrap space-x-4">
{jobTypes?.map((data, index)=> (
<CheckBox
value={data.value}
onChange={(e) => CheckBoxHandle(e, jobtype, setJobType)}
checked = {jobtype.includes(data.value)} 
label={<FormattedMessage id={data.label}></FormattedMessage>}
/>
))}
   </div>
      {error && <div className="text-red-500 text-sm mt-3">{error}</div>}
   </>
  )
})
